import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { catchError, from, map, Observable, of, shareReplay, switchMap } from "rxjs";
import { environment } from "src/environments/environment.generated";

@Injectable()
export class MockInterceptor implements HttpInterceptor {
    intercept(
        req: HttpRequest<any>,
        next: HttpHandler
    ): Observable<HttpEvent<any>> {
        if (!environment.mock) {
            return next.handle(req);
        }

        const { method } = req;
        const path = new URL(req.url, document.baseURI).pathname;
        
        // GET consents/v1/processorDrivers?expandon=SCOPE CONSENT_OBJECT PROCESSOR
        if (method === 'GET' && path.endsWith('/processorDrivers')) {
            console.log(`INTERCEPTED GET /processorDrivers`);
            return from(
                import('../../../assets/mock-data/processor-drivers.json')
            ).pipe(
                map(m => new HttpResponse({ status: 200, body: m.default })),
                catchError(() => next.handle(req))
            );
        }

        // PATCH consents/v1/processorDrivers/{processorDriverId} with the body {“status”:”REVOKED”}
        // if (method === 'PATCH' && path.match(/\/processorDrivers\/\d+S/) && req.body?.status === 'REVOKED') {
        if (method === 'PATCH') {
            console.log(`INTERCEPTED PATCH /processorDrivers/{id}`);
            return from(
                import('../../../assets/mock-data/patch-response.json')
            ).pipe(
                map(m => new HttpResponse({ status: 200, body: m.default })),
                catchError(() => next.handle(req))
            );
        }

        return next.handle(req);
    }
}